var _metadata, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "400.000000pt",
    height: "108.000000pt",
    viewBox: "0 0 400.000000 108.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.16, written by Peter Selinger 2001-2019\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,108.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243 913 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418 913 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338 903 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263 893 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398 893 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318 873 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238 843 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398 843 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308 813 c18 -2 45 -2 60 0 15 2 0 4 -33 4 -33 0 -45 -2 -27 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227 803 c-14 -13 -7 -23 16 -22 19 1 19 2 3 6 -15 4 -16 7 -5 14 8 5 9 9 3 9 -6 0 -14 -3 -17 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430 806 c0 -2 7 -7 16 -10 8 -3 12 -2 9 4 -6 10 -25 14 -25 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323 793 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534 788 c-4 -7 -4 -10 1 -6 4 4 15 2 24 -5 14 -11 14 -10 2 6 -16 20 -18 21 -27 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418 783 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471 788 c2 -2 18 -14 34 -28 l30 -25 -24 28 c-14 15 -29 27 -34 27 -6 0 -8 -1 -6 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268 753 c12 -2 30 -2 40 0 9 3 -1 5 -23 4 -22 0 -30 -2 -17 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363 753 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273 733 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368 733 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510 725 c8 -11 15 -21 16 -23 1 -2 5 5 8 15 4 9 4 14 0 10 -4 -4 -14 -1 -23 6 -14 11 -15 10 -1 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551 674 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630 630 c0 -33 3 -60 8 -60 4 0 7 27 7 60 0 33 -3 60 -7 60 -5 0 -8 -27 -8 -60z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1820 595 l0 -85 -40 0 c-39 0 -40 -1 -40 -35 0 -34 1 -35 40 -35 l40 0 0 -154 c0 -176 8 -210 52 -225 71 -25 118 -12 118 34 0 31 -2 33 -35 32 -19 -1 -38 3 -42 7 -4 4 -10 75 -11 157 l-4 149 101 0 101 0 0 -127 c1 -157 9 -200 50 -235 26 -24 39 -28 94 -28 56 0 70 4 115 34 l51 35 0 -30 c0 -27 2 -29 40 -29 l40 0 0 225 0 225 -40 0 -40 0 0 -153 0 -153 -27 -26 c-35 -32 -85 -58 -113 -58 -24 0 -61 18 -72 34 -4 6 -8 89 -8 184 l0 172 -145 0 -145 0 0 85 0 85 -40 0 -40 0 0 -85z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3110 370 l0 -310 45 0 45 0 0 310 0 310 -45 0 -45 0 0 -310z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3290 370 l0 -310 40 0 40 0 0 310 0 310 -40 0 -40 0 0 -310z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503 635 c0 -22 2 -30 4 -17 2 12 2 30 0 40 -3 9 -5 -1 -4 -23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602 630 c0 -19 2 -27 5 -17 2 9 2 25 0 35 -3 9 -5 1 -5 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317 603 c-4 -3 -6 -45 -5 -92 l2 -86 6 90 c4 50 4 -33 2 -182 -4 -203 -2 -273 6 -273 9 0 12 73 12 275 0 151 -4 275 -8 275 -5 0 -12 -3 -15 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551 584 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364 567 c-3 -8 -4 -32 -1 -53 3 -37 4 -36 7 11 l3 50 7 -50 7 -50 1 47 c2 46 -13 73 -24 45z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591 554 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443 536 l-18 -21 24 20 c13 11 25 19 28 17 3 -2 7 -2 9 1 2 2 -3 4 -11 4 -8 0 -23 -10 -32 -21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516 542 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6 -4 -9 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616 534 c-3 -9 -1 -23 4 -32 9 -14 10 -12 4 7 -4 16 -3 21 5 17 6 -4 11 -3 11 3 0 18 -18 21 -24 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M875 497 c-89 -42 -135 -116 -135 -214 1 -97 56 -181 142 -217 55 -23 158 -21 213 5 138 65 179 247 83 364 -43 52 -100 77 -183 82 -59 3 -78 0 -120 -20z m179 -61 c54 -23 86 -79 86 -151 0 -70 -22 -114 -72 -145 -40 -24 -116 -27 -158 -5 -113 59 -113 239 1 297 41 22 98 23 143 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1470 509 c-13 -6 -39 -21 -57 -35 l-33 -25 0 30 c0 30 -1 31 -45 31 l-45 0 0 -225 0 -225 45 0 45 0 0 159 0 158 39 27 c78 54 151 54 171 1 6 -15 10 -98 10 -186 l0 -159 40 0 40 0 0 194 c0 191 0 193 -25 220 -13 14 -36 31 -50 36 -33 12 -102 12 -135 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2692 507 c-91 -33 -147 -120 -146 -227 2 -138 93 -230 229 -230 60 0 112 17 134 43 19 24 31 21 31 -8 0 -22 4 -25 40 -25 l40 0 0 225 0 225 -40 0 c-36 0 -40 -2 -40 -25 0 -26 -14 -33 -26 -14 -24 40 -153 61 -222 36z m189 -93 c43 -41 59 -76 59 -129 0 -58 -31 -120 -73 -145 -39 -24 -118 -26 -156 -4 -85 50 -104 188 -37 263 53 59 153 66 207 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3608 510 c-52 -16 -98 -52 -126 -98 -23 -41 -27 -58 -27 -128 0 -72 3 -86 30 -130 44 -71 107 -104 200 -104 46 0 83 7 110 19 39 17 115 91 115 111 0 23 -62 9 -106 -25 -40 -31 -53 -35 -102 -35 -67 0 -112 23 -142 72 -42 68 -43 68 176 68 l197 0 -7 51 c-13 96 -76 177 -156 199 -41 12 -124 12 -162 0z m169 -80 c32 -19 63 -66 63 -95 0 -13 -21 -15 -150 -15 -96 0 -150 4 -150 10 0 29 33 82 62 100 44 27 131 27 175 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526 458 c3 -5 10 -6 15 -3 13 9 11 12 -6 12 -8 0 -12 -4 -9 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385 448 c-8 -23 -10 -388 -2 -388 4 0 7 87 7 194 0 194 0 195 23 199 l22 4 -23 2 c-12 0 -25 -5 -27 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485 441 c-9 -15 15 -25 28 -12 9 9 7 10 -7 5 -13 -5 -17 -4 -12 4 4 7 5 12 2 12 -3 0 -7 -4 -11 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551 426 c-15 -16 -19 -26 -12 -31 7 -3 10 -1 9 6 -2 7 3 13 11 14 8 0 15 8 17 18 3 22 2 22 -25 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460 410 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500 390 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468 205 c-2 -80 0 -145 5 -145 4 0 7 65 7 145 0 80 -2 145 -4 145 -3 0 -6 -65 -8 -145z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.af13dd0b8165895931ecb16268a2b079.svg";
export { ForwardRef as ReactComponent };